import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { shareClassesStateJ } from '../../../services/state/CapTableFormStateJ';
import { IInvestmentGridRow, IOtherInvestmentsGridRow } from './InvestmentGridDefs';
import { updateInvestmentRows } from './investment-utils';
import { getShareClassesForOtherInvestments } from './OtherInvestmentsDefs';

// share class state might change as users goes back and forth through the steps;
// this removes any share classes that are not in the current state, adds default values for any newly created share classes
// and deletes rows that are missing fundId
// Note that we would reset the values for any renamed shares

export function useSyncClientInvestmentDataWithSharesState() {
  const shareClasses = useAtomValue(shareClassesStateJ);

  return useCallback(
    (investmentRows: IInvestmentGridRow[]) => {
      return updateInvestmentRows(investmentRows, shareClasses, 'fundId');
    },
    [shareClasses]
  );
}

export function useSyncOtherInvestmentDataWithSharesState() {
  const shareClasses = useAtomValue(shareClassesStateJ);

  return useCallback(
    (rows: IOtherInvestmentsGridRow[]) => {
      return updateInvestmentRows(rows, getShareClassesForOtherInvestments(shareClasses), 'investor');
    },
    [shareClasses]
  );
}
